
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class SamplePopover extends Vue {
  @Prop({ type: String, default: '' }) sample_img!: string;
  @Prop({ type: Number, default: '' }) height!: number;
}
